'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n'], ['\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  height: 40px;\n  width: 50px;\n  position: relative;\n  display: inline-block;\n  font-size: 20px;\n  line-height: 40px;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 5px;\n  font-family: Roboto;\n'], ['\n  height: 40px;\n  width: 50px;\n  position: relative;\n  display: inline-block;\n  font-size: 20px;\n  line-height: 40px;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 5px;\n  font-family: Roboto;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject);

var Square = _styledComponents2.default.div(_templateObject2);

var getColor = function getColor(data, style) {
  var styleColor = Object.assign({}, style);
  var scoreNum = parseFloat(data);
  var borderColor = _color2.default.grey_accent_1;
  var textcolor = _color2.default.grey_accent_1;

  if (!isNaN(scoreNum)) {
    if (scoreNum >= 4.0 && scoreNum <= 5.0) {
      borderColor = _color2.default.g10;
      textcolor = _color2.default.g10;
    } else if (scoreNum >= 3.0 && scoreNum < 4.0) {
      borderColor = _color2.default.g09;
      textcolor = _color2.default.g09;
    } else if (scoreNum >= 2.0 && scoreNum < 3.0) {
      borderColor = _color2.default.r34;
      textcolor = _color2.default.r34;
    } else if (scoreNum >= 0.0 && scoreNum < 2.0) {
      borderColor = _color2.default.r12;
      textcolor = _color2.default.r12;
    } else {
      borderColor = _color2.default.grey_accent_1;
      textcolor = _color2.default.grey_accent_1;
    }
  }

  styleColor.border = '1px solid ' + borderColor;
  styleColor.color = textcolor;
  return styleColor;
};

var MozartSquareBadge = function MozartSquareBadge(props) {
  var style = props.style,
      data = props.data;

  var style_ = getColor(data, style);

  var dataIsValid = typeof data === 'undefined' || data === null ? false : true;
  var isNA = String(data) === 'N/A';
  var isInteger = String(data).indexOf('.') === -1;
  var score = !isNA && isInteger ? String(data) + '.0' : data;

  return _react2.default.createElement(
    Container,
    { 'data-qa': props.testId, 'data-theme': props.themeId },
    _react2.default.createElement(
      Square,
      { style: style_ },
      dataIsValid ? score : 'N/A'
    )
  );
};

MozartSquareBadge.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** style override */
  style: _propTypes2.default.object,
  /** content */
  data: _propTypes2.default.oneOf([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.number])
};

MozartSquareBadge.defaultProps = {
  style: {},
  testId: 'MozartSquareBadge',
  themeId: 'MozartSquareBadge'
};

exports.default = MozartSquareBadge;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartBadge/MozartSquareBadge/MozartSquareBadge.js
// module id = 1831
// module chunks = 1